import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'productHasProperty'
})
export class ProductHasPropertyPipe implements PipeTransform {
    transform(item: { product_properties?: Array<{ code: string }> } | null, property: string): boolean {
        return item?.product_properties?.some((p) => p.code === property) ?? false;
    }
}
